export default __webpack_public_path__ + "static/1-487169740d5c995b18663905f18e8dc6.jpeg";